import { defineMessages } from 'react-intl';

export default defineMessages({
  uploadTitle: {
    id: 'LeadListCreate.uploadTitle',
    defaultMessage: 'Select a File',
  },
});
